import React from 'react';
import PropTypes from 'prop-types';
import DivLayout from 'components/sales/divLayout/divLayout';
import localization from 'assets/localization/localization';
import DocumentView from 'components/sales/downloadDocView/documentView';

const MeetingData = ({ details }) => {
  return (
    <div className="panel-card">
      <div className="panel-heading">{localization.meetingDetails}</div>
      <div className="panel-body">
        <div className="details-listing">
          <DivLayout
            heading={localization.raisedTo}
            data={details?.client_name ? details.client_name : ''}
          />
          <DivLayout
            heading={localization.scheduledDate}
            data={
              details?.meeting_date ? details.meeting_date : localization.na
            }
          />
          <DivLayout
            heading={localization.scheduledTime}
            data={
              details?.meeting_time ? details.meeting_time : localization.na
            }
          />
          <DivLayout
            heading={localization.status}
            data={details?.status ? details.status : localization.na}
          />
          <DivLayout
            heading={localization.subject}
            data={details?.subject ? details.subject : localization.na}
          />
          <DivLayout
            heading={localization.summary}
            data={details?.summary ? details.summary : localization.na}
          />
          {details && details.attachment ? (
            <DocumentView attachment={details.attachment} />
          ) : null}
        </div>
      </div>
    </div>
  );
};

MeetingData.propTypes = {
  details: PropTypes.any,
};

export default MeetingData;
